import styled from 'styled-components';
import Spinner from './Spinner';

const Overlay = styled.div`
  width: 999%;
  height: 999%;
  position: absolute;
  z-index: 100000;
  overflow: hidden;
`;

const DivInOverlay = styled(Overlay)`
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
`;

const SpinnerWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100001;
`;


const Loader = ({isInBox = false}) => {
  return (
    <>
      {!isInBox ? (
        <>
          <Overlay />
          <Spinner />
        </>
      ) : (
        <>
          <DivInOverlay />
          <SpinnerWrap>
            {/* <img src="/images/loading.svg" width="64" alt="Spinner" /> 이중으로 생기는 로딩바 wrap에서 호출 시 이미지만 제거 */}
          </SpinnerWrap>
        </>
      )}
    </>
  );
}

export default Loader;
